<template>
  <div class="shop">
    <span style="margin-right:4px;color:#666;">收支类型:</span>
    <el-select
      size="mini"
      v-model="form.type"
      placeholder="请选择收支类型"
      @change="onChangeRedtype"
      style="width:120px;"
    >
      <el-option label="红包充值" value="0">红包充值</el-option>
      <el-option label="红包使用" value="1">红包使用</el-option>
    </el-select>

    <!-- <el-select
      size="mini"
      v-model="form.source_from"
      style="width:160px;margin-left:8px;"
    >
      <el-option
        v-for="item in reduceList"
        :key="'s' + item.value"
        :value="item.value"
        :label="item.name"
      ></el-option>
    </el-select> -->
    <el-autocomplete
      size="mini"
      style="width:160px;margin-left:8px;"
      popper-class="my-autocomplete"
      v-model="AutoVal"
      :fetch-suggestions="querySearch"
      placeholder="请输入内容"
      @select="handleSelect"
    >
      <template slot-scope="{ item }">
        <div class="name">{{ item.val }}</div>
      </template>
    </el-autocomplete>
    <span style="margin-left:12px;margin-right:4px;color:#666;">时间段:</span>
    <el-date-picker
      v-model="form.start_date"
      type="date"
      style="width:136px;margin-right:6px;"
      value-format="yyyy-MM-dd"
      size="mini"
      placeholder="开始时间"
    ></el-date-picker>
    <span style="color:#666;">——</span>
    <el-date-picker
      v-model="form.end_date"
      type="date"
      style="width:136px;margin-left:6px;"
      size="mini"
      value-format="yyyy-MM-dd"
      placeholder="结束时间"
    ></el-date-picker>
    <div style="margin-top:10px">
      <el-input
        v-model="form.mobile"
        size="mini"
        placeholder="请输入用户账号搜索"
        style="width:160px;margin-right:10px"
      ></el-input>
      <el-button size="mini" @click="searchUserRedList">搜索</el-button>
      <!-- <el-button size="mini" type="primary" @click="exportUserRedList"
        >导出</el-button
      > -->
    </div>

    <el-table
      :data="tableData"
      max-height="720"
      style="width:100%;margin:20px;"
      :cell-style="tc"
      :header-cell-style="tccolor"
      v-loading="loading"
    >
      <el-table-column label="时间">
        <template slot-scope="scope">{{
          formatTime(scope.row.create_time, 'Y-M-D h:m:s')
        }}</template>
      </el-table-column>
      <el-table-column label="红包收支类型">
        <template slot-scope="scope">
          <p v-if="scope.row.type == 0">红包充值</p>
          <p v-if="scope.row.type == 1">红包使用</p>
        </template>
      </el-table-column>
      <el-table-column label="用户账号" prop="mobile">
        <template slot-scope="scope">
          <p v-if="scope.row.user">{{ scope.row.user.mobile }}</p>
          <p v-else>---</p>
        </template>
      </el-table-column>
      <el-table-column label="充值使用类型" width="240">
        <template slot-scope="scope">
          <!-- <p v-if="scope.row.source_from == 0 && scope.row.type == 1">
            红包兑换商品
          </p>
          <span v-if="scope.row.source_from == 1 && scope.row.type == 1"
            >点对点红包转赠</span
          >
          <span v-if="scope.row.source_from == 2 && scope.row.type == 1"
            >发群红包</span
          >
          <p v-if="scope.row.source_from == 3 && scope.row.type == 0">
            付费充值
          </p>
          <p v-if="scope.row.source_from == 5 && scope.row.type == 0">
            点对点收红包
          </p>
          <p v-if="scope.row.source_from == 2 && scope.row.type == 0">
            购物红包退回
          </p>
          <p v-if="scope.row.source_from == 8">群红包收入</p>
          <span v-if="scope.row.source_from == 6">群红包退回</span>
          <p v-if="scope.row.source_from == 4">系统充值</p>
          <p v-if="scope.row.source_from == 10">买单返红包</p> -->

          <span
            style="cursor:pointer;color:#f4222d;margin-left:12px;"
            v-if="scope.row.source_from == 2 && scope.row.type == 1"
            @click="watchGetRecord(scope.row.orderid)"
            >领取记录</span
          >
          <span v-else>{{ scope.row.source_from_word }}</span>
        </template>
      </el-table-column>
      <el-table-column label="转赠人">
        <template slot-scope="scope">
          <p>
            {{
              scope.row.send_user_mobile ? scope.row.send_user_mobile : '---'
            }}
          </p>
        </template>
      </el-table-column>
      <el-table-column label="变动金额">
        <template slot-scope="scope">
          <p v-if="scope.row.type == 0">+ {{ scope.row.money_tlj }}</p>
          <p v-if="scope.row.type == 1">- {{ scope.row.money_tlj }}</p>
        </template>
      </el-table-column>
      <el-table-column label="备注" prop="remark"></el-table-column>
    </el-table>

    <div class="pagination">
      <el-pagination
        background
        @current-change="pageChange"
        :current-page="form.page"
        :page-size="form.size"
        layout="total, prev, pager, next, jumper"
        :total="total"
      ></el-pagination>
    </div>

    <jdialog
      title="红包领取记录"
      :visible.sync="showRedGetRecord"
      width="540px"
    >
      <div style="padding:20px;">
        <div
          v-for="(item, index) in recordList"
          :key="'s' + index"
          style="margin-bottom:10px;height:64px;"
        >
          <img
            :src="item.wxheadpic"
            style="width:60px;height:60px;float:left;margin-right:6px;"
          />
          <p style="padding:8px 4px 4px 4px;width:240px;">
            {{ item.receive_user }}
          </p>
          <p style="margin-left:8px;color:#666;font-size:14px;width:240px;">
            {{ item.created_at }}
          </p>

          <p style="float:right;color:#f4222d;margin-top:-30px;">
            {{ item.receive_money }}
          </p>
        </div>
      </div>
    </jdialog>
  </div>
</template>

<script>
import { cardTljList, redPacketGetDetail, sourceFrom } from '@/api/managent'
import { API_BASE_URL } from '@/config'
export default {
  data() {
    return {
      loading: false,
      uid: '',
      form: {
        type: this.$route.query.type ? this.$route.query.type : '',
        source_from: '',
        start_date: '',
        end_date: '',
        mobile: this.$route.query.mobile ? this.$route.query.mobile : '',
        is_export: 0,
        page: 1,
        size: 20,
        filename: ''
      },
      AutoVal: '',
      reduceList: [],
      reduceMsg: '',
      tableData: [],
      total: 0,
      showRedGetRecord: false,
      recordList: []
    }
  },
  mounted() {
    this.getTljRedListData()
    this.getSourceFrom()
  },
  methods: {
    getSourceFrom() {
      sourceFrom()
        .then(res => {
          console.log(res)

          this.reduceMsg = res.data
          this.reduceList = res.data.inc_source_from
        })
        .catch(err => {
          console.log(err)
        })
    },

    querySearch(queryString, cb) {
      var restaurants = this.reduceList
      var results = queryString
        ? restaurants.filter(this.createFilter(queryString))
        : restaurants
      // 调用 callback 返回建议列表的数据
      console.log(results)
      cb(results)
    },
    createFilter(queryString) {
      return reduceList => {
        return (
          reduceList.val.toLowerCase().indexOf(queryString.toLowerCase()) === 0
        )
      }
    },
    handleSelect(item) {
      console.log(item)
      this.form.source_from = item.key
      this.AutoVal = item.val
    },

    onChangeRedtype(e) {
      this.form.source_from = ''
      if (e == 0) {
        //红包充值
        this.reduceList = this.reduceMsg.inc_source_from
      } else if (e == 1) {
        //红包使用
        this.reduceList = this.reduceMsg.dec_source_from
      }
    },

    //获取红包列表
    async getTljRedListData() {
      console.log(this.form.type)
      var url =
        'page=' +
        this.form.page +
        '&size=' +
        this.form.size +
        '&type=' +
        this.form.type +
        '&source_from=' +
        this.form.source_from +
        '&start_date=' +
        this.form.start_date +
        '&end_date=' +
        this.form.end_date +
        '&mobile=' +
        this.form.mobile +
        '&uid=' +
        this.uid +
        '&is_export=' +
        this.form.is_export +
        '&filename=' +
        this.form.filename

      let res = await cardTljList(url)
      if (res.code === 10000) {
        this.form.filename = res.data.filename
        if (this.form.is_export === 1) {
          this.form.is_export = 0
          this.loading = true
          this.exportOut(res.data.page, res.data.filename)
          // window.open(
          //   `${API_BASE_URL}/admin/download/zip/${res.data.download_token}`
          // )
          return
        } else {
          this.tableData = res.data.data || []
          this.total = res.data.total
        }
      } else {
        this.form.is_export = 0
        this.$message.error(res.message)
      }
    },

    async exportOut(page, filename) {
      var url =
        'page=' +
        page +
        '&size=' +
        this.form.size +
        '&type=' +
        this.form.type +
        '&source_from=' +
        this.form.source_from +
        '&start_date=' +
        this.form.start_date +
        '&end_date=' +
        this.form.end_date +
        '&mobile=' +
        this.form.mobile +
        '&uid=' +
        this.uid +
        '&is_export=1' +
        '&filename=' +
        filename
      let res = await cardTljList(url)
      if (res.code === 10000) {
        if (res.data.code === 2) {
          this.exportOut(res.data.page, res.data.filename)
        } else if (res.data.code === 1) {
          this.loading = false
          window.open(
            `${API_BASE_URL}/admin/download/zip/${res.data.download_token}`
          )
        } else {
          this.loading = false
          this.$message.error(res.data.message)
        }
      } else {
        this.loading = false
        this.form.is_export = 0
        this.$message.error(res.message)
      }
    },

    pageChange(page) {
      this.form.page = page
      this.getTljRedListData()
    },
    searchUserRedList() {
      this.form.page = 1
      this.getTljRedListData()
    },
    // 导出数据
    exportUserRedList() {
      this.form.is_export = 1
      this.getTljRedListData()
    },
    watchGetRecord(id) {
      this.getredPacketGetDetailData(id)
    },
    async getredPacketGetDetailData(id) {
      let res = await redPacketGetDetail(id)
      if (res.code === 10000) {
        if (res.data.total == 0) {
          this.$message.error('无领取记录')
        } else {
          this.showRedGetRecord = true
          this.recordList = res.data.data
        }
      } else {
        this.$message.error(res.message)
      }
    },
    formatNumber(n) {
      n = n.toString()
      return n[1] ? n : '0' + n
    },
    formatTime(number, format) {
      var formateArr = ['Y', 'M', 'D', 'h', 'm', 's']
      var returnArr = []

      var date = new Date(number * 1000)
      returnArr.push(date.getFullYear())
      returnArr.push(this.formatNumber(date.getMonth() + 1))
      returnArr.push(this.formatNumber(date.getDate()))

      returnArr.push(this.formatNumber(date.getHours()))
      returnArr.push(this.formatNumber(date.getMinutes()))
      returnArr.push(this.formatNumber(date.getSeconds()))

      for (var i in returnArr) {
        format = format.replace(formateArr[i], returnArr[i])
      }
      return format
    },
    tc() {
      return 'text-align:center; color:#333333; font-size:12px;'
    },
    tccolor() {
      return 'text-align:center;background-color:#f5f5f5; font-size:14px;'
    }
  }
}
</script>

<style lang="scss" scoped>
.shop {
  padding: 20px;
  .pagination {
    float: right;
    margin: 20px 0;
  }
}
</style>
